var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0331 7.10974C22.0483 7.323 22.0483 7.53636 22.0483 7.74962C22.0483 14.2547 17.0991 21.75 8.05331 21.75C5.26648 21.75 2.67768 20.9426 0.5 19.5411C0.895967 19.5867 1.27664 19.602 1.68781 19.602C3.98726 19.602 6.10406 18.825 7.79445 17.4996C5.63201 17.4539 3.81981 16.0371 3.19541 14.0871C3.50001 14.1328 3.80456 14.1633 4.1244 14.1633C4.56601 14.1633 5.00766 14.1023 5.41878 13.9957C3.16497 13.5386 1.47458 11.5582 1.47458 9.16641V9.1055C2.12937 9.47112 2.89086 9.69964 3.6979 9.73004C2.37304 8.84644 1.50507 7.33825 1.50507 5.632C1.50507 4.71795 1.74865 3.88005 2.1751 3.14881C4.59641 6.13473 8.23605 8.0847 12.3172 8.29801C12.2411 7.93239 12.1954 7.55156 12.1954 7.17069C12.1954 4.45898 14.3883 2.25 17.1142 2.25C18.5305 2.25 19.8096 2.84414 20.7081 3.80389C21.8198 3.59063 22.8857 3.1793 23.83 2.61562C23.4644 3.75824 22.6878 4.71799 21.6675 5.32733C22.6574 5.22072 23.6168 4.94646 24.5 4.56564C23.8301 5.5406 22.9924 6.40895 22.0331 7.10974Z",
    fill: "#38A1F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.257b0cc4f279c5e17197d5b823c5f648.svg";
export { ForwardRef as ReactComponent };